// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".moving-images-image-input-answer-form[data-v-86de9bca]{position:relative}.drag-and-drop[data-v-86de9bca]{margin-bottom:10px}.uploader[data-v-86de9bca]{margin-bottom:16px}.images-match-picker[data-v-86de9bca],.text-match-picker[data-v-86de9bca]{margin-bottom:20px}.left-border[data-v-86de9bca]{position:absolute;top:0;left:-30px;width:4px;height:100%;background-color:#ebae28}", ""]);
// Exports
module.exports = exports;
